export default __webpack_public_path__ + "static/media/paper-machine-cover.909dc352.png";